module.exports = __webpack_public_path__ + "static/media/69.c5f2c8aa.jpg";